export const kranevoTranslations = {
  en: {
    breadcrumb: { home: 'Home', locations: 'Locations', kranevo: 'Kranevo' },
    hero: {
      badge: 'Kranevo, Black Sea Coast',
      heading: 'Kranevo Beach Sports Facility',
      subheading: 'Beach Sports & Multi-Sport Training on the Black Sea',
      beachVolleyball: 'Beach Volleyball',
      multiSport: 'Multi-Sport',
      idealForSummer: 'Ideal for summer camps',
      sportsList: 'Beach Volleyball, Football, Basketball',
      stars: '5/5 stars',
      bookFacility: 'Book This Facility',
    },
    overview: {
      heading: 'Facility Overview',
      cards: [
        { heading: 'Facility Type', content: 'Beach Sports Complex', subtext: 'Unique coastal training environment' },
        { heading: 'Capacity', content: 'Multiple Sessions', subtext: 'Ideal for summer training camps' },
        { heading: 'Surfaces', content: 'Beach & Indoor', subtext: 'Beach courts and indoor halls' },
        { heading: 'Location', content: 'Black Sea Coast', subtext: 'Beautiful coastal setting' },
      ],
    },
    about: {
      heading: 'About Kranevo Beach Sports Facility',
      description: "Located on Bulgaria's beautiful Black Sea coast, Kranevo offers a unique training environment combining beach sports facilities with traditional training venues. This coastal facility provides the perfect setting for summer training camps, combining the benefits of beach training with indoor backup facilities for year-round versatility.",
      keyHighlights: 'Key Highlights',
      highlights: [
        'Dedicated beach volleyball courts on the Black Sea',
        'Indoor sports halls for year-round training',
        'Outdoor training fields for football and other sports',
        'Direct beach access for additional training opportunities',
        'Professional fitness facilities and gym equipment',
        'Modern locker rooms and changing facilities',
        'Cafeteria and dining services',
        'Nearby accommodation options',
        'Ideal for summer training camps and beach sports competitions',
      ],
      testimonial: '"A unique coastal training facility combining the best of beach sports and traditional training, perfect for memorable summer training camps."',
      testimonialAttribution: 'Champion Maker Team',
    },
    sports: {
      heading: 'Available Sports & Activities',
      beachVolleyball: 'Beach Volleyball',
      beachVolleyballDesc: 'Professional beach volleyball courts on the Black Sea coast, perfect for beach volleyball training and competitions in a stunning coastal setting.',
      viewSpecs: 'View Specifications',
      hideSpecs: 'Hide Specifications',
      beachCourtFacilities: 'Beach Court Facilities:',
      beachCourtList: ['Multiple beach volleyball courts', 'Professional sand surface', 'Net systems meeting FIVB standards', 'Beach access for additional training', 'Spectator areas'],
      idealFor: 'Ideal For:',
      beachIdealFor: ['Beach volleyball training camps', 'Summer training programs', 'Beach volleyball tournaments', 'Indoor to beach transition training', 'Coastal training experiences'],
      indoorFootball: 'Indoor Sports & Football',
      indoorFootballDesc: 'Indoor sports halls for basketball and volleyball, plus outdoor football fields. Perfect for year-round training regardless of weather conditions.',
      facilitiesAvailable: 'Facilities Available:',
      indoorFacilitiesList: ['Indoor sports halls (basketball, volleyball)', 'Outdoor football fields', 'Professional gym facilities', 'Fitness training areas', 'All-weather training options'],
      indoorIdealFor: ['Multi-sport training camps', 'Year-round training programs', 'Weather-independent training', 'Combined beach and indoor training', 'Comprehensive sports development'],
    },
    paralympic: {
      heading: 'Paralympic Sports & Inclusive Training',
      subheading: 'Fully Accessible Facilities for Paralympic Athletes',
      introTitle: 'Inclusive Training Environment',
      introText: 'Kranevo Beach Sports Facility is committed to providing world-class training opportunities for Paralympic athletes. Our facility features fully accessible infrastructure and specialized equipment to support athletes of all abilities in achieving their performance goals.',
      keyFeatures: 'Key Features for Paralympic Athletes:',
      features: [
        'Wheelchair-accessible beach volleyball courts',
        'Fully accessible indoor sports halls',
        'Adapted equipment available for rent',
        'Accessible changing rooms and facilities',
        'Beach access assistance and ramps',
        'Trained staff for Paralympic sports support',
        'Accessible parking and pathways',
        'Medical support familiar with adaptive sports',
      ],
      beachParaVolleyball: 'Beach Para Volleyball',
      beachParaDesc: 'Specially adapted beach volleyball courts designed for wheelchair athletes, featuring appropriate court dimensions and accessible net heights meeting international Paralympic standards.',
      beachParaFeatures: ['Wheelchair-accessible court surfaces', 'Adapted net systems', 'Beach wheelchair access', 'Professional coaching available'],
      indoorParaSports: 'Indoor Para Sports',
      indoorParaDesc: 'Fully accessible indoor sports halls supporting various Paralympic disciplines including wheelchair basketball, sitting volleyball, and other adaptive sports.',
      indoorParaFeatures: ['Wheelchair basketball courts', 'Sitting volleyball facilities', 'Adaptive equipment storage', 'Year-round training availability'],
      accessibilityServices: 'Accessibility Services',
      accessibilityDesc: 'Comprehensive accessibility support including specialized equipment, trained staff, and facilities designed to ensure all athletes can train effectively and safely.',
      accessibilityFeatures: ['Beach wheelchairs available', 'Adaptive sports equipment', 'Accessible accommodation coordination', 'Medical support for adaptive athletes'],
      ctaTitle: 'Committed to Paralympic Excellence',
      ctaText: 'We welcome Paralympic athletes and teams from around the world. Our facility is designed to support athletes of all abilities in achieving their training goals. Contact us to discuss your specific accessibility needs and training requirements.',
      bookParalympic: 'Book Paralympic Training',
    },
    amenities: {
      heading: 'World-Class Facilities & Amenities',
      items: [
        { title: 'Modern Locker Rooms', desc: 'Spacious changing facilities with showers, lockers, and beach access' },
        { title: 'Equipment Storage', desc: 'Secure storage areas for sports equipment and personal belongings' },
        { title: 'Beach Access', desc: 'Direct access to Black Sea beach for additional training opportunities' },
        { title: 'Parking Available', desc: 'Convenient parking facilities for teams and visitors' },
        { title: 'Equipment Rental', desc: 'Beach and indoor sports equipment available for rent' },
        { title: 'WiFi Available', desc: 'High-speed wireless internet throughout the facility' },
        { title: 'Cafeteria Services', desc: 'On-site refreshments and meal options available' },
        { title: 'Medical Facilities', desc: 'First aid and medical assistance available' },
        { title: 'Nearby Accommodation', desc: 'Beachfront hotels and resorts in close proximity' },
        { title: 'Fitness Facilities', desc: 'Professional gym with strength & conditioning equipment' },
        { title: 'Professional Lighting', desc: 'LED lighting for evening beach and indoor training' },
        { title: 'Climate Control', desc: 'Indoor facilities with optimal temperature control' },
      ],
    },
    gallery: {
      heading: 'Facility Gallery',
      subheading: 'Explore our world-class athletics training environment Videos',
    },
    galleryImages: { heading: 'Facility Gallery Images' },
    access: {
      heading: 'Location & How to Get Here',
      address: 'Address',
      addressLine1: 'Kranevo Beach Sports Facility',
      addressLine2: 'Kranevo',
      addressLine3: 'Black Sea Coast, Bulgaria',
      getDirections: 'Get Directions',
      byCar: 'By Car',
      car1: 'Parking available on-site',
      car2: 'Easy access from coastal roads',
      car3: 'Scenic drive along the Black Sea coast',
      byBus: 'By Public Transport',
      bus1: 'Bus lines available to Kranevo',
      bus2: 'Connections from Varna and other coastal cities',
      bus3: 'Short walk from bus stops to facility',
      fromAirports: 'From Airports',
      airport1: 'Varna Airport: 30 km (35-40 min by car)',
      airport2: 'Sofia Airport: 450 km (5-6 hours by car)',
      airport3: 'We provide airport transfer services',
      nearbyAttractions: 'Nearby Attractions',
      nearby1: 'Black Sea beaches - Direct access',
      nearby2: 'Varna city center - 30 km away',
      nearby3: 'Coastal resorts and restaurants nearby',
    },
    pricing: {
      heading: 'Pricing & Availability',
      flexiblePricing: 'Flexible Pricing Options',
      pricingVaries: 'Pricing varies based on:',
      factors: [
        'Duration of booking (hourly, half-day, full-day, multi-day)',
        'Season (summer peak vs. off-season)',
        'Beach and indoor facilities needed',
        'Additional services required',
        'Equipment rental needs',
        'Support staff requirements',
      ],
      pricingNote: 'For detailed pricing and package options, please contact us with your specific requirements. Summer season pricing may vary.',
      whatsIncluded: "What's Included:",
      included: [
        'Beach court access for specified time',
        'Indoor facility access',
        'Basic equipment (balls, nets)',
        'Locker room facilities',
        'Beach access',
        'On-site staff support',
      ],
      optionalAddons: 'Optional Add-ons:',
      addons: [
        'Equipment rental (beach volleyball sets, footballs, etc.)',
        'Extended hours',
        'Professional coaching services',
        'Beach training equipment',
        'Medical support',
        'Accommodation coordination',
      ],
      requestQuote: 'Request a Quote',
    },
    testimonials: {
      heading: 'What Teams Say About Training Here',
      items: [
        { quote: "Kranevo provided the perfect beach training environment for our volleyball team. The combination of beach courts and indoor facilities was ideal, and the Black Sea location made it a memorable training camp experience.", name: "Coach Elena Marinova", date: "September 2025" },
        { quote: "Excellent beach sports facility with great access to the Black Sea. Our team loved training on the beach courts and the indoor facilities provided perfect backup for weather changes. Highly recommend!", name: "Coach David Thompson", date: "August 2025" },
        { quote: "The unique coastal training environment at Kranevo was perfect for our summer training camp. Beach volleyball, football on the beach, and indoor facilities - everything we needed in one location.", name: "Coach Maria Santos", date: "July 2025" },
        { quote: "Outstanding facility combining beach and traditional sports. The beach access and nearby accommodation made our training camp seamless. Perfect for summer training programs.", name: "Coach Hans Weber", date: "June 2025" },
      ],
    },
    similar: {
      heading: 'Explore Other Locations',
      viewDetails: 'View Details',
      locations: [
        { name: 'Sofia, Mladost', location: 'Sofia, Mladost', badge: 'Basketball & Volleyball', description: 'Modern basketball and volleyball training facility', path: '/locations/sofia-mladost' },
        { name: 'Sofia, Boyana', location: 'Sofia, Boyana', badge: 'Multi-Sport', description: 'Comprehensive multi-sport training facility', path: '/locations/sofia-boyana' },
        { name: 'Plovdiv Aquatic Center', location: 'Plovdiv', badge: 'Swimming', description: 'Olympic-size swimming pool and aquatic center', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'Frequently Asked Questions',
      items: [
        { question: 'What beach sports are available?', answer: 'The facility features dedicated beach volleyball courts and supports beach football training. The Black Sea beach access provides additional training opportunities.' },
        { question: 'What happens if the weather is bad?', answer: 'The facility includes indoor sports halls and training facilities, so training can continue regardless of weather conditions. Both beach and indoor options are available.' },
        { question: 'Is accommodation available nearby?', answer: 'Yes, there are nearby accommodation options close to the facility. We can arrange lodging at beachfront hotels or resorts in the Kranevo area.' },
        { question: 'What are the facility operating hours?', answer: 'The facility operates from 7:00 AM to 10:00 PM daily. Beach facilities are available during daylight hours, while indoor facilities are available throughout operating hours.' },
        { question: 'Is this facility only for summer training?', answer: 'While ideal for summer training camps, the indoor facilities allow for year-round training. Beach sports are best during warmer months, but indoor sports can be trained year-round.' },
        { question: 'How far is it from Varna Airport?', answer: 'Kranevo is approximately 30 km from Varna Airport, about 35-40 minutes by car. We provide airport transfer services from both Varna and Sofia airports.' },
        { question: 'Can we host beach volleyball tournaments here?', answer: 'Absolutely! The facility is equipped for hosting beach volleyball tournaments and competitions with multiple beach courts and spectator areas.' },
        { question: 'What indoor facilities are available?', answer: 'The facility includes indoor sports halls for basketball, volleyball, and other sports, plus fitness facilities and training areas for year-round use.' },
        { question: 'Is the facility accessible for people with disabilities?', answer: 'Yes, the facility is wheelchair accessible with appropriate facilities for athletes and visitors with disabilities. Beach access assistance can be arranged.' },
        { question: 'Are there restaurants and dining options nearby?', answer: 'Yes, the facility has a cafeteria, and there are numerous restaurants and dining options in the Kranevo area, including beachfront restaurants.' },
      ],
    },
    cta: {
      heading: 'Ready to Book Kranevo Beach Sports Facility?',
      subheading: 'Contact us to reserve your training dates',
      sendInquiry: 'Send a quick inquiry',
      requestInfo: 'Request Information',
      speakWithTeam: 'Speak with our team',
      getCompletePackage: 'Get a complete package',
      bookCompletePackage: 'Book Complete Package',
      ctaCallNow: 'Call Now',
    },
  },
  ar: {
    breadcrumb: { home: 'الرئيسية', locations: 'المواقع', kranevo: 'كرانييفو' },
    hero: {
      badge: 'كرانييفو، ساحل البحر الأسود',
      heading: 'منشأة كرانييفو الرياضية الشاطئية',
      subheading: 'رياضات شاطئية وتدريب متعدد الرياضات على البحر الأسود',
      beachVolleyball: 'كرة الطائرة الشاطئية',
      multiSport: 'متعدد الرياضات',
      idealForSummer: 'مثالي للمعسكرات الصيفية',
      sportsList: 'كرة الطائرة الشاطئية، كرة القدم، كرة السلة',
      stars: '5/5 نجوم',
      bookFacility: 'احجز هذه المنشأة',
    },
    overview: {
      heading: 'نظرة عامة على المنشأة',
      cards: [
        { heading: 'نوع المنشأة', content: 'مجمع رياضي شاطئي', subtext: 'بيئة تدريب ساحلية فريدة' },
        { heading: 'السعة', content: 'جلسات متعددة', subtext: 'مثالي لمعسكرات التدريب الصيفية' },
        { heading: 'الأسطح', content: 'شاطئي وداخلي', subtext: 'ملاعب شاطئية وقاعات داخلية' },
        { heading: 'الموقع', content: 'ساحل البحر الأسود', subtext: 'إعداد ساحلي جميل' },
      ],
    },
    about: {
      heading: 'عن منشأة كرانييفو الرياضية الشاطئية',
      description: 'تقع كرانييفو على الساحل الجميل للبحر الأسود في بلغاريا، وتوفر بيئة تدريب فريدة تجمع بين مرافق الرياضات الشاطئية وملاعب التدريب التقليدية. توفر هذه المنشأة الساحلية الإعداد المثالي لمعسكرات التدريب الصيفية، مع الجمع بين مزايا التدريب الشاطئي والمرافق الداخلية الاحتياطية للتنوع على مدار العام.',
      keyHighlights: 'أبرز المميزات',
      highlights: [
        'ملاعب كرة طائرة شاطئية مخصصة على البحر الأسود',
        'قاعات رياضية داخلية للتدريب على مدار العام',
        'ملاعب تدريب خارجية لكرة القدم ورياضات أخرى',
        'وصول مباشر للشاطئ لفرص تدريب إضافية',
        'مرافق لياقة بدنية ومعدات صالة رياضية احترافية',
        'غرف خلع ملابس ومرافق تغيير حديثة',
        'كافيتريا وخدمات طعام',
        'خيارات إقامة قريبة',
        'مثالي لمعسكرات التدريب الصيفية ومسابقات الرياضات الشاطئية',
      ],
      testimonial: '"منشأة تدريب ساحلية فريدة تجمع أفضل ما في الرياضات الشاطئية والتدريب التقليدي، مثالية لمعسكرات التدريب الصيفية التي لا تُنسى."',
      testimonialAttribution: 'فريق صناع الأبطال',
    },
    sports: {
      heading: 'الرياضات والأنشطة المتاحة',
      beachVolleyball: 'كرة الطائرة الشاطئية',
      beachVolleyballDesc: 'ملاعب كرة طائرة شاطئية احترافية على ساحل البحر الأسود، مثالية لتدريب ومسابقات كرة الطائرة الشاطئية في إعداد ساحلي خلاب.',
      viewSpecs: 'عرض المواصفات',
      hideSpecs: 'إخفاء المواصفات',
      beachCourtFacilities: 'مرافق الملاعب الشاطئية:',
      beachCourtList: ['ملاعب كرة طائرة شاطئية متعددة', 'سطح رمل احترافي', 'أنظمة شباك تلبي معايير الاتحاد الدولي للكرة الطائرة', 'وصول للشاطئ للتدريب الإضافي', 'مناطق للمتفرجين'],
      idealFor: 'مثالي لـ:',
      beachIdealFor: ['معسكرات تدريب كرة الطائرة الشاطئية', 'برامج التدريب الصيفية', 'بطولات كرة الطائرة الشاطئية', 'تدريب الانتقال من الداخلي للشاطئي', 'تجارب التدريب الساحلية'],
      indoorFootball: 'الرياضات الداخلية وكرة القدم',
      indoorFootballDesc: 'قاعات رياضية داخلية لكرة السلة والطائرة، بالإضافة إلى ملاعب كرة قدم خارجية. مثالية للتدريب على مدار العام بغض النظر عن ظروف الطقس.',
      facilitiesAvailable: 'المرافق المتاحة:',
      indoorFacilitiesList: ['قاعات رياضية داخلية (كرة سلة، كرة طائرة)', 'ملاعب كرة قدم خارجية', 'مرافق صالة رياضية احترافية', 'مناطق تدريب لياقة', 'خيارات تدريب لجميع الأجواء'],
      indoorIdealFor: ['معسكرات تدريب متعددة الرياضات', 'برامج تدريب على مدار العام', 'تدريب مستقل عن الطقس', 'تدريب مشترك شاطئي وداخلي', 'تطوير رياضي شامل'],
    },
    paralympic: {
      heading: 'الرياضات البارالمبية والتدريب الشامل',
      subheading: 'مرافق متاحة بالكامل للرياضيين البارالمبيين',
      introTitle: 'بيئة تدريب شاملة',
      introText: 'تلتزم منشأة كرانييفو الرياضية الشاطئية بتوفير فرص تدريب عالمية المستوى للرياضيين البارالمبيين. تتميز منشأتنا ببنية تحتية متاحة بالكامل ومعدات متخصصة لدعم الرياضيين بجميع قدراتهم في تحقيق أهدافهم الأدائية.',
      keyFeatures: 'المميزات الرئيسية للرياضيين البارالمبيين:',
      features: [
        'ملاعب كرة طائرة شاطئية متاحة للكراسي المتحركة',
        'قاعات رياضية داخلية متاحة بالكامل',
        'معدات متكيفة متاحة للتأجير',
        'غرف تغيير ومرافق متاحة',
        'مساعدة الوصول للشاطئ ومنحدرات',
        'طاقم مدرب لدعم الرياضات البارالمبية',
        'مواقف سيارات وممرات متاحة',
        'دعم طبي ملم بالرياضات التكيفية',
      ],
      beachParaVolleyball: 'كرة الطائرة البارالمبية الشاطئية',
      beachParaDesc: 'ملاعب كرة طائرة شاطئية متكيفة خصيصًا لرياضيي الكراسي المتحركة، بأبعاد ملعب مناسبة وارتفاعات شباك متاحة تلبي المعايير البارالمبية الدولية.',
      beachParaFeatures: ['أسطح ملعب متاحة للكراسي المتحركة', 'أنظمة شباك متكيفة', 'وصول كراسي الشاطئ المتحركة', 'تدريب احترافي متاح'],
      indoorParaSports: 'الرياضات البارالمبية الداخلية',
      indoorParaDesc: 'قاعات رياضية داخلية متاحة بالكامل تدعم تخصصات بارالمبية مختلفة بما في ذلك كرة السلة على الكراسي المتحركة والكرة الطائرة الجالسة ورياضات تكيفية أخرى.',
      indoorParaFeatures: ['ملاعب كرة سلة للكراسي المتحركة', 'مرافق كرة طائرة جالسة', 'تخزين معدات تكيفية', 'توفر التدريب على مدار العام'],
      accessibilityServices: 'خدمات إمكانية الوصول',
      accessibilityDesc: 'دعم شامل لإمكانية الوصول يشمل معدات متخصصة وطاقم مدرب ومرافق مصممة لضمان تدريب جميع الرياضيين بفعالية وأمان.',
      accessibilityFeatures: ['كراسي شاطئ متحركة متاحة', 'معدات رياضية تكيفية', 'تنسيق إقامة متاحة', 'دعم طبي للرياضيين التكيفيين'],
      ctaTitle: 'ملتزمون بالتميز البارالمبي',
      ctaText: 'نرحب بالرياضيين والفرق البارالمبية من جميع أنحاء العالم. صُممت منشأتنا لدعم الرياضيين بجميع قدراتهم في تحقيق أهدافهم التدريبية. اتصل بنا لمناقشة احتياجات إمكانية الوصول ومتطلبات التدريب المحددة.',
      bookParalympic: 'احجز التدريب البارالمبي',
    },
    amenities: {
      heading: 'مرافق وخدمات عالمية المستوى',
      items: [
        { title: 'غرف خلع ملابس حديثة', desc: 'مرافق تغيير واسعة مع دوش وخزائن ووصول للشاطئ' },
        { title: 'تخزين المعدات', desc: 'مناطق تخزين آمنة للمعدات الرياضية والممتلكات الشخصية' },
        { title: 'وصول للشاطئ', desc: 'وصول مباشر لشاطئ البحر الأسود لفرص تدريب إضافية' },
        { title: 'موقف سيارات متاح', desc: 'مرافق انتظار مريحة للفرق والزوار' },
        { title: 'تأجير المعدات', desc: 'معدات رياضية شاطئية وداخلية متاحة للتأجير' },
        { title: 'واي فاي متاح', desc: 'إنترنت لاسلكي عالي السرعة في جميع أنحاء المنشأة' },
        { title: 'خدمات كافيتريا', desc: 'مرطبات ووجبات متاحة في الموقع' },
        { title: 'مرافق طبية', desc: 'إسعافات أولية ومساعدة طبية متاحة' },
        { title: 'إقامة قريبة', desc: 'فنادق ومنتجعات على الشاطئ على مقربة' },
        { title: 'مرافق لياقة', desc: 'صالة رياضية احترافية مع معدات القوة والتكييف' },
        { title: 'إضاءة احترافية', desc: 'إضاءة LED للتدريب الشاطئي والداخلي المسائي' },
        { title: 'التحكم بالمناخ', desc: 'مرافق داخلية بتحكم مثالي في درجة الحرارة' },
      ],
    },
    gallery: {
      heading: 'معرض المنشأة',
      subheading: 'استكشف بيئة التدريب الرياضي عالمية المستوى - فيديوهات',
    },
    galleryImages: { heading: 'صور معرض المنشأة' },
    access: {
      heading: 'الموقع وكيفية الوصول',
      address: 'العنوان',
      addressLine1: 'منشأة كرانييفو الرياضية الشاطئية',
      addressLine2: 'كرانييفو',
      addressLine3: 'ساحل البحر الأسود، بلغاريا',
      getDirections: 'الحصول على الاتجاهات',
      byCar: 'بالسيارة',
      car1: 'موقف سيارات متاح في الموقع',
      car2: 'وصول سهل من الطرق الساحلية',
      car3: 'مشاهد خلابة على طول ساحل البحر الأسود',
      byBus: 'بالنقل العام',
      bus1: 'خطوط حافلات متاحة إلى كرانييفو',
      bus2: 'اتصالات من فارنا ومدن ساحلية أخرى',
      bus3: 'مسافة قصيرة سيراً من محطات الحافلات إلى المنشأة',
      fromAirports: 'من المطارات',
      airport1: 'مطار فارنا: 30 كم (35-40 دقيقة بالسيارة)',
      airport2: 'مطار صوفيا: 450 كم (5-6 ساعات بالسيارة)',
      airport3: 'نوفر خدمات نقل من المطار',
      nearbyAttractions: 'معالم قريبة',
      nearby1: 'شواطئ البحر الأسود - وصول مباشر',
      nearby2: 'وسط مدينة فارنا - 30 كم',
      nearby3: 'منتجعات ومطاعم ساحلية قريبة',
    },
    pricing: {
      heading: 'الأسعار والتوفر',
      flexiblePricing: 'خيارات أسعار مرنة',
      pricingVaries: 'تختلف الأسعار حسب:',
      factors: [
        'مدة الحجز (بالساعة، نصف يوم، يوم كامل، أيام متعددة)',
        'الموسم (ذروة الصيف مقابل خارج الموسم)',
        'المرافق الشاطئية والداخلية المطلوبة',
        'الخدمات الإضافية المطلوبة',
        'احتياجات تأجير المعدات',
        'متطلبات طاقم الدعم',
      ],
      pricingNote: 'للحصول على تفاصيل الأسعار وخيارات الباقات، يرجى الاتصال بنا مع متطلباتك المحددة. قد تختلف أسعار موسم الصيف.',
      whatsIncluded: 'ما الذي يُدرج:',
      included: [
        'وصول للملاعب الشاطئية للوقت المحدد',
        'وصول المرافق الداخلية',
        'معدات أساسية (كرات، شباك)',
        'مرافق غرف خلع الملابس',
        'وصول للشاطئ',
        'دعم الطاقم في الموقع',
      ],
      optionalAddons: 'إضافات اختيارية:',
      addons: [
        'تأجير معدات (مجموعات كرة طائرة شاطئية، كرات قدم، إلخ)',
        'ساعات إضافية',
        'خدمات تدريب احترافية',
        'معدات التدريب الشاطئية',
        'دعم طبي',
        'تنسيق الإقامة',
      ],
      requestQuote: 'طلب عرض أسعار',
    },
    testimonials: {
      heading: 'ماذا تقول الفرق عن التدريب هنا',
      items: [
        { quote: 'وفرت كرانييفو بيئة تدريب شاطئية مثالية لفريق الكرة الطائرة لدينا. كان الجمع بين الملاعب الشاطئية والمرافق الداخلية مثالياً، وجعل موقع البحر الأسود التجربة لا تُنسى.', name: 'المدرب إيلينا مارينوفا', date: 'سبتمبر 2025' },
        { quote: 'منشأة رياضية شاطئية ممتازة مع وصول رائع للبحر الأسود. أحب فريقنا التدريب على الملاعب الشاطئية ووفرت المرافق الداخلية احتياطياً مثاليًا لتغيرات الطقس. أوصي بشدة!', name: 'المدرب ديفيد طومسون', date: 'أغسطس 2025' },
        { quote: 'كانت بيئة التدريب الساحلية الفريدة في كرانييفو مثالية لمعسكر التدريب الصيفي لدينا. كرة الطائرة الشاطئية، كرة القدم على الشاطئ، والمرافق الداخلية - كل ما نحتاجه في موقع واحد.', name: 'المدرب ماريا سانتوس', date: 'يوليو 2025' },
        { quote: 'منشأة متميزة تجمع الرياضات الشاطئية والتقليدية. جعل الوصول للشاطئ والإقامة القريبة معسكر تدريبنا سلساً. مثالي لبرامج التدريب الصيفية.', name: 'المدرب هانز ويبر', date: 'يونيو 2025' },
      ],
    },
    similar: {
      heading: 'استكشف مواقع أخرى',
      viewDetails: 'عرض التفاصيل',
      locations: [
        { name: 'صوفيا، ملادوست', location: 'صوفيا، ملادوست', badge: 'كرة السلة والطائرة', description: 'منشأة تدريب حديثة لكرة السلة والطائرة', path: '/locations/sofia-mladost' },
        { name: 'صوفيا، بويانا', location: 'صوفيا، بويانا', badge: 'متعدد الرياضات', description: 'منشأة تدريب رياضية شاملة', path: '/locations/sofia-boyana' },
        { name: 'مركز بلوفديف المائي', location: 'بلوفديف', badge: 'السباحة', description: 'مسبح أولمبي ومركز مائي', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'الأسئلة الشائعة',
      items: [
        { question: 'ما الرياضات الشاطئية المتاحة؟', answer: 'تضم المنشأة ملاعب كرة طائرة شاطئية مخصصة وتدعم تدريب كرة القدم الشاطئية. يوفر وصول شاطئ البحر الأسود فرص تدريب إضافية.' },
        { question: 'ماذا يحدث إذا كان الطقس سيئاً؟', answer: 'تضم المنشأة قاعات رياضية داخلية ومرافق تدريب، لذا يمكن الاستمرار في التدريب بغض النظر عن ظروف الطقس. الخيارات الشاطئية والداخلية متاحة.' },
        { question: 'هل تتوفر إقامة قريبة؟', answer: 'نعم، هناك خيارات إقامة قريبة من المنشأة. يمكننا ترتيب الإقامة في فنادق أو منتجعات على الشاطئ في منطقة كرانييفو.' },
        { question: 'ما ساعات عمل المنشأة؟', answer: 'تعمل المنشأة من 7:00 صباحاً إلى 10:00 مساءً يومياً. المرافق الشاطئية متاحة خلال ساعات النهار، والمرافق الداخلية متاحة طوال ساعات العمل.' },
        { question: 'هل هذه المنشأة للتدريب الصيفي فقط؟', answer: 'بينما هي مثالية لمعسكرات التدريب الصيفية، تسمح المرافق الداخلية بالتدريب على مدار العام. الرياضات الشاطئية أفضل في الأشهر الدافئة، لكن الرياضات الداخلية يمكن تدريبها على مدار العام.' },
        { question: 'كم تبعد عن مطار فارنا؟', answer: 'كرانييفو على بعد حوالي 30 كم من مطار فارنا، نحو 35-40 دقيقة بالسيارة. نوفر خدمات نقل من مطاري فارنا وصوفيا.' },
        { question: 'هل يمكننا تنظيم بطولات كرة طائرة شاطئية هنا؟', answer: 'بالتأكيد! المنشأة مجهزة لاستضافة بطولات ومسابقات كرة الطائرة الشاطئية مع ملاعب شاطئية متعددة ومناطق للمتفرجين.' },
        { question: 'ما المرافق الداخلية المتاحة؟', answer: 'تضم المنشأة قاعات رياضية داخلية لكرة السلة والطائرة ورياضات أخرى، بالإضافة إلى مرافق لياقة ومناطق تدريب للاستخدام على مدار العام.' },
        { question: 'هل المنشأة متاحة لذوي الاحتياجات الخاصة؟', answer: 'نعم، المنشأة متاحة للكراسي المتحركة مع مرافق مناسبة للرياضيين والزوار ذوي الاحتياجات الخاصة. يمكن ترتيب مساعدة الوصول للشاطئ.' },
        { question: 'هل هناك مطاعم وخيارات طعام قريبة؟', answer: 'نعم، المنشأة لديها كافيتريا، وهناك مطاعم وخيارات طعام عديدة في منطقة كرانييفو، بما في ذلك مطاعم على الشاطئ.' },
      ],
    },
    cta: {
      heading: 'مستعد لحجز منشأة كرانييفو الرياضية الشاطئية؟',
      subheading: 'اتصل بنا لحجز مواعيد التدريب',
      sendInquiry: 'أرسل استفساراً سريعاً',
      requestInfo: 'طلب معلومات',
      speakWithTeam: 'تحدث مع فريقنا',
      getCompletePackage: 'احصل على باقة كاملة',
      bookCompletePackage: 'احجز الباقة الكاملة',
      ctaCallNow: 'اتصل الآن',
    },
  },
};
